// Module
var code = "<md-button class=\"md-icon-button margin-0\" ng-click=\"$ctrl.downloadFile()\"> <md-icon md-svg-icon=\"download\" class=\"bringoz-icon primary-200\"></md-icon> <md-tooltip class=\"bringoz-tooltip\" md-direction=\"top\">{{$ctrl.description || 'Download' | translate}}</md-tooltip> </md-button> ";
// Exports
export default code;